module.exports = __webpack_public_path__ + "media/images/pic/schab-b011bb2b61f41280405029150307b372.jpg";